import axios from 'axios'
import { csrfToken } from '../csrfToken'

/**
 * Uploads a file through the app and resolves to what it hands back: the
 * image's CDN URL (the app writes it to Bunny Storage), or for ID documents
 * a token for the file it sent to Stripe.
 */
export const uploadFile = async (
  uploadPath: string,
  file: File,
  localiseUrl: (path: string, options: { localeAsParam: boolean }) => string = (
    path
  ) => path
): Promise<string | undefined> => {
  const upload = new FormData()

  upload.append('file', file)
  upload.append('authenticity_token', csrfToken)

  const { data } = await axios.post<{ location: string }>(
    localiseUrl(uploadPath, { localeAsParam: true }),
    upload
  )

  return data.location
}

export const fileSizeString = (fileSizeInBytes: number): string => {
  let fileSizeInB = fileSizeInBytes
  let i = -1
  const byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB']

  do {
    fileSizeInB /= 1024
    i += 1
  } while (fileSizeInB > 1024)

  return `${Math.max(fileSizeInB, 0.1).toFixed(1)}${byteUnits[i]}`
}
